// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__RWBSw","description":"MealItem_description__nZyon","price":"MealItem_price__xmf+1"};